import api from './api'
import { ItemService } from '@/services'

const namespaced = true

const state = {
  searchFiles: []
}

const getters = {
  searchFiles: state => state.searchFiles
}

const actions = {
  getSearchResults (_context, params) {
    return new Promise((resolve) => {
      api
        .getSearchResults(params)
        .then(ItemService.decodeItems)
        .then(({ items, nextToken }) => {
          resolve({ items, nextToken })
        })
    })
  },
  setSearchFiles ({ commit }, files) {
    commit('setSearchFiles', files)
  },
  setFile ({ commit }, file) {
    commit('setFile', file)
  },
  removeFile ({ commit }, file) {
    commit('removeFile', file)
  }
}

const mutations = {
  setSearchFiles (state, files) {
    if (files.length === 0) state.searchFiles = []
    else state.searchFiles = state.searchFiles.concat(files)
  },
  setFile (state, file) {
    const fileIndex = state.searchFiles.findIndex(f => {
      return f.id === file.id
    })
    if (fileIndex > -1) {
      state.searchFiles.splice(fileIndex, 1, file)
    }
  },
  removeFile (state, file) {
    const fileIndex = state.searchFiles.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state.searchFiles.splice(fileIndex, 1)
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
